// load-more-posts.js
// Simple module - no IIFE needed, ES6 modules already have scope
window.loadMorePosts = function() {
    // Get data from the container element
    const container = document.querySelector('[x-data*="loadMorePosts"]');
    if (!container) {
        return {
            loading: false,
            hasMore: false,
            page: 1,
            category: 0,
            loadMore: function() {}
        };
    }

    const hasMore = container.dataset.hasMore === 'true';
    const currentPage = parseInt(container.dataset.currentPage) || 1;
    const category = parseInt(container.dataset.category) || 0;
    const lang = container.dataset.currentLang || '';
    const apiUrl = container.dataset.apiUrl || '';

    return {
        loading: false,
        hasMore: hasMore,
        page: currentPage,
        category: category,
        lang: lang,

        async loadMore() {
            this.loading = true;
            this.page++;

            try {
                const response = await fetch(`${apiUrl}?page=${this.page}&category=${this.category}&lang=${this.lang}`);
                const data = await response.json();

                if (data.html && data.html.trim() !== '') {
                    // Get the grid container
                    const grid = this.$refs.postsContainer.querySelector('.grid');

                    // Insert the HTML directly
                    grid.insertAdjacentHTML('beforeend', data.html);

                    this.hasMore = data.has_more;
                } else {
                    this.hasMore = false;
                }
            } catch (error) {
                console.error('Error loading posts:', error);
            } finally {
                this.loading = false;
            }
        }
    };
};